import { inject, Provider } from '@angular/core';
import { DEVICE_ROLES, GATEWAY_ROLES, SITE_ROLES } from '@wheere-front/inside-shared-data-access';
import { AuthStore } from '@wheere-front/shared-auth';
import { COMMAND_PALETTE_CONFIG, CommandPaletteConfig, CommandResultKind } from '@wheere-front/shared-ui';

/** Ce que la règle lit d'{@link AuthStore} : la même fonction que la garde `userHasAnyRole`. */
export interface InsidePaletteAuth {
  hasAnyRole(roles: string | string[]): boolean;
  isPlatformUser(): boolean;
}

/**
 * Types de résultat de la palette ⌘K ouvrables dans inside : ceux dont la route accepte
 * l'utilisateur (`app.routes.ts` : `/sites` SITE_ROLES, `/devices` DEVICE_ROLES, `/gateways`
 * GATEWAY_ROLES). Une organisation mène à `/sites` après avoir posé le scope : plateforme seulement.
 */
export function insideCommandPaletteKinds(auth: InsidePaletteAuth): CommandResultKind[] {
  const kinds: CommandResultKind[] = [];
  const sites = auth.hasAnyRole(SITE_ROLES);
  if (sites) kinds.push('site');
  if (auth.hasAnyRole(DEVICE_ROLES)) kinds.push('device');
  if (auth.hasAnyRole(GATEWAY_ROLES)) kinds.push('gateway');
  if (sites && auth.isPlatformUser()) kinds.push('org');
  return kinds;
}

/** Palette d'inside : types permis par les gardes ; appareils du client généré, baromètres compris. */
export function provideInsideCommandPalette(): Provider {
  return {
    provide: COMMAND_PALETTE_CONFIG,
    useFactory: (): CommandPaletteConfig => {
      const auth = inject(AuthStore);
      return {
        allowedKinds: () => insideCommandPaletteKinds(auth),
        // Fiche tracker d'inside : /devices/trackers/:trackerId (DEVICES_ROUTES), pas /devices/:id.
        deviceRoute: id => ['/devices/trackers', id],
      };
    },
  };
}
